import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FlyoutManageViewList.theme.scss';
import ViewLink from './ViewLink';

const ViewListItem = ({bookmark = {}, currentViewId, user, isAdmin, clickBookmark, copyBookmark, deleteBookmark}) => {
	const isGlobal = bookmark.isGlobal;
	const isActive = bookmark._id === currentViewId ? true : false;

	return (
		<div className={styles.row}>
			<div className={styles.rowInfo}>
				<div className={classNames({'list-icon-btn': true, 'active-text': isActive, 'no-rollover': true})}>
					<i title={isGlobal ? 'Global' : 'User'} className="material-icons">
						{isGlobal ? 'language' : 'person'}
					</i>
				</div>
				<div
					className={classNames({'list-icon-btn': true, 'active-text': isActive, 'link-text': true})}
					onClick={() => clickBookmark(bookmark)}
				>
					{bookmark.name}
				</div>
				{bookmark.isDefault && (
					<div className={classNames({'list-icon-btn': true, 'active-text': isActive, 'no-rollover': true})}>
						<i title="Default" className="material-icons">
							home
						</i>
					</div>
				)}
				{bookmark.isFavorite && (
					<div className={classNames({'list-icon-btn': true, 'active-text': isActive, 'no-rollover': true})}>
						<i title="Favorite" className="material-icons">
							star
						</i>
					</div>
				)}
			</div>
			<div className={styles.rowActions}>
				<ViewLink
					isAdmin={isAdmin}
					allowAll={true}
					title="Copy"
					alt="Copy View"
					iconName="content_copy"
					onClick={() => copyBookmark(bookmark)}
					user={user}
					bookmark={bookmark}
				/>
				<ViewLink
					isAdmin={isAdmin}
					allowAll={false}
					title="Delete"
					alt="Delete View"
					iconName="delete"
					onClick={() => deleteBookmark(bookmark)}
					user={user}
					bookmark={bookmark}
				/>
			</div>
		</div>
	);
};

ViewListItem.propTypes = {
	bookmark: PropTypes.object,
	currentViewId: PropTypes.string,
	user: PropTypes.object,
	isAdmin: PropTypes.bool,
	clickBookmark: PropTypes.func,
	copyBookmark: PropTypes.func,
	deleteBookmark: PropTypes.func,
};

export default ViewListItem;
